<template>
  <div class="graph-container">
    <canvas id="graph" ref="graph" />
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    label: {
      type: String,
      require: true,
      default: String
    },
    labels: {
      type: Array,
      require: true,
      default: Array
    },
    values: {
      type: Array,
      require: true,
      default: Array
    },
    backgroundColor: {
      type: Array,
      require: true,
      default: Array
    },
    borderColor: {
      type: Array,
      require: true,
      default: Array
    },
    hoverBackgroundColor: {
      type: Array,
      require: true,
      default: Array
    },
    hoverBorderColor: {
      type: Array,
      require: true,
      default: Array
    },
    updateChart: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  watch: {
    updateChart(val) {
      if (val === true) {
        this.update();
      }
    }
  },
  methods: {
    update() {
      this.myBarChart.data.datasets[0].data = this.values;
      this.myBarChart.update({
        lazy: true
      });
    }
  },

  mounted() {
    let max = Math.max.apply(null, this.values);
    let gap = 50;
    let maxValue = 400;
    let context = this.$refs.graph.getContext("2d");
    let options = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: gap,
              max:maxValue
            }
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    let data = {
      labels: this.labels,
      datasets: [
        {
          label: this.label,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: 1,
          hoverBackgroundColor: this.hoverBackgroundColor,
          hoverBorderColor: this.hoverBorderColor,
          data: this.values
        }
      ]
    };

    this.myBarChart = new Chart(context, {
      type: "bar",
      data: data,
      options: options
    });
  },

  beforeDestroy() {
    this.myBarChart.destroy();
  }
};
</script>

<style scoped>
.graph-container {
  height: 450px;
}
</style>
